(($, Drupal) => {
    const id = "xencms:paragraph--text";

    Drupal.behaviors[id] = {
        attach: (context, settings) => {
            once(id, ".paragraph--text", context).forEach(paragraph => {
                if ($('.typed-cursor').length < 2 && $('#type-text').attr('data-text')?.length) {
                    var text = $('#type-text').attr('data-text').split(", ");
                    new Typed('#type-text', { strings: text, typeSpeed: 100, backDelay: 500, loop: true })
                }

                $('.prompt-input-wrapper textarea').focusin(function () {
                    $('.prompt-input-wrapper .custom-input-field').addClass('hide');
                }).focusout(function () {
                    if (!$(this).val())
                        $('.prompt-input-wrapper .custom-input-field').removeClass('hide');
                });

                if ($('.typed-cursor').length < 2 && $('#type-text-2').attr('data-text')?.length) {
                    var text = $('#type-text-2').attr('data-text').split(", ");
                    new Typed('#type-text-2', { strings: text, typeSpeed: 50, backDelay: 500, loop: true })
                }

                if ($('.custom-bg-color').length == 1) {
                    $('.custom-bg-color').parent().parent().parent().addClass('custom-bg-color')
                }

                if ($('.custom-card__item').length) {
                    $('.prompt-input-wrapper.pm-site .wrapper').hide();

                    $('.custom-card__item').click(function () {
                        $(this).addClass('active').siblings().removeClass('active')
                        $('.prompt-input-wrapper.pm-site .wrapper').show("fast");
                        $('.prompt-input-wrapper textarea').val($(this).attr('data-prompt'))
                        // $('.custom-card__link').attr('href', $('.custom-card__link').first().attr('data-default-link') + '?pm=' + $(this).attr('data-link'))
                    })
                }
            })

            once('text-prompt', '.prompt-input-wrapper textarea', context).forEach(text => {
                $('.prompt-input-wrapper textarea').keydown(function () {
                    if (event.key === 'Enter' && !event.shiftKey) {
                        event.preventDefault();
                        submitPrompt($(this).val(), $('.prompt-input-wrapper').attr('data-source'))
                    }
                })

                $('.prompt-input-wrapper .submit-button').click(function () {
                    if ($('.prompt-input-wrapper textarea').val()) {
                        event.preventDefault();
                        submitPrompt($('.prompt-input-wrapper textarea').val(), $('.prompt-input-wrapper').attr('data-source'))
                    }
                })
            })

            function submitPrompt(prompt, source, template = null) {
                targetDomain = 'https://app.smartoo.io';
                // targetDomain = 'https://staging-x.smartoo.io'; //staging
                fetch(targetDomain + '/api/public/build-intents', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    mode: 'cors',
                    credentials: 'omit',
                    body: JSON.stringify({
                        source: source,
                        prompt: prompt,
                        anonymousId: getSmartooAnonymousId(),
                        landingPath: window.location.pathname,
                        templateId: template ?? '',
                        utm: Object.fromEntries(new URLSearchParams(window.location.search)),
                    }),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.data.id) {
                            window.open(targetDomain + `/teams/welcome?buildIntent=${data.data.id}`, '_blank')
                        }
                    })
                    .catch(error => console.error('Error:', error))
            }

            function getSmartooAnonymousId() {
                const key = 'smartoo_anonymous_id'
                let id = localStorage.getItem(key)

                if (!id) {
                    id = window.crypto?.randomUUID
                        ? window.crypto.randomUUID()
                        : `${Date.now()}-${Math.random().toString(36).slice(2)}`

                    localStorage.setItem(key, id)
                }

                return id
            }
        }
    };
})(jQuery, Drupal);
